import { ASSETS } from '../assetManifest';

let loadingProgress = 0;

const preloadAssets = () => {
  const uniqueUrls = new Set();
  const addUrls = (obj) => {
    Object.values(obj).forEach(value => {
      if (typeof value === 'string' && value.startsWith('assets')) {
        uniqueUrls.add(value);
      } else if (typeof value === 'object') {
        addUrls(value);
      }
    });
  };
  addUrls(ASSETS);

  const totalAssets = uniqueUrls.size;
  let loadedAssets = 0;

  const loadImage = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      const timeout = setTimeout(() => {
        resolve();
      }, 10000);

      img.onload = () => {
        clearTimeout(timeout);
        resolve();
      };

      img.onerror = () => {
        clearTimeout(timeout);
        resolve();
      };

      img.src = url;
    });
  };

  const loadAllImages = async () => {
    const promises = Array.from(uniqueUrls).map(url =>
      loadImage(url).then(() => {
        loadedAssets++;
        loadingProgress = (loadedAssets / totalAssets) * 100;
      })
    );
    await Promise.all(promises);
  };

  loadAllImages();
};

export const getLoadingProgress = () => {
  return loadingProgress;
};

export const getStartData = () => {
  // Start preloading when data is first requested
  if (loadingProgress === 0) {
    preloadAssets();
  }

  return {
    fonts: {
      ui: 'Futhark'
    }
  };
};
